<template>
    <div>
        <b-form-group class="questions">
            <div v-for="(item, index) in form" :key="index">
                <label>
                    {{ item.question.text }}
                </label>

                <b-input-group>
                    <b-form-input
                        type="text"
                        v-model="item.answer.text"
                        @input="save"
                        placeholder="Your answer">    
                    </b-form-input>

                    <b-input-group-append>
                        <b-button 
                            @click.prevent="item.answer.text = ''">
                            Clear
                        </b-button>
                    </b-input-group-append>
                </b-input-group>
            </div>

<!--            <b-button variant="primary" @click.prevent="save">-->
<!--                Save Answers-->
<!--            </b-button>-->

        </b-form-group>
    </div>
</template>

<script>
    export default {
        props: {
            questions: {
                required: true
            },

            answers: {}
        },

        data() {
            return {
                form: []
            }
        },

        mounted() {
            this.form = this.questions.map((question) => {
                return {
                    question: question,
                    answer: this.answers.find((answer) => {
                        return answer.question_id == question.id
                    }) || {
                        text: ""
                    }
                }
            });
        },

        methods: {
            save() {

                // let out=[];
                // this.form.forEach(i=>out.push(i));
                this.$emit('changed', [...this.form]);
            }
        }
    }
</script>

<style scoped lang="scss">
    .questions {
        margin-top: 0!important;

        .input-group {
            margin-bottom: 10px;
        }

        input {
            margin-bottom: 0!important;
        }
    }
</style>